import { MarketplaceComponentConfig } from '@nocode/types';

export default {
  name: 'ChangeQuantity',
  displayName: {
    en: 'ChangeQuantity',
    ja: 'プラグイン名',
  },
  minWidth: 100,
  resizeX: true,
  resizeY: true,
  props: [
    {
      name: 'value',
      type: 'number',
      role: 'formValue',
    },
    {
      name: 'defaultQuantity',
      displayName: {
        en: 'Initial value',
        ja: '初期値',
      },
      type: 'number',
      default: '1',
    },
    {
      name: 'minimum',
      displayName: {
        en: 'Minimum',
        ja: '最小値',
      },
      type: 'number',
      default: '1',
    },
    {
      name: 'maximum',
      displayName: {
        en: 'Maximum',
        ja: '最大値',
      },
      type: 'number',
      default: '10',
    },
    {
      name: 'color',
      type: 'color',
      displayName: {
        en: 'Text color',
        ja: 'テキストカラー',
      },
      default: '#000',
    },
    {
      name: 'iconBackgroundColor',
      displayName: {
        en: 'Primary color',
        ja: 'プライマリカラー',
      },
      type: 'color',
      default: '#fdc42b',
    },
    {
      name: 'fontSize',
      type: 'fontSize',
    },
  ],
} as MarketplaceComponentConfig;
